export default "__VITE_ASSET__19ee3a55__"